import React from 'react';
import { ArrowLeftIcon, ShoppingCartIcon } from 'lucide-react';
import { NotificationBadge } from './NotificationBadge';
interface HeaderProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  actionButton?: React.ReactNode;
  showLogo?: boolean;
  showNotifications?: boolean;
  notificationCount?: number;
  onNotificationClick?: () => void;
  showCart?: boolean;
  cartItemCount?: number;
  onCartClick?: () => void;
}
export function Header({
  title,
  showBack = false,
  onBack,
  actionButton,
  showLogo = false,
  showNotifications = false,
  notificationCount = 0,
  onNotificationClick,
  showCart = false,
  cartItemCount = 0,
  onCartClick
}: HeaderProps) {
  return <header className="bg-white text-[#1f5070] px-6 py-4 shadow-sm" data-id="element-108">
      <div className="flex items-center justify-between" data-id="element-109">
        <div className="flex items-center gap-4 flex-1" data-id="element-110">
          {showBack && <button onClick={onBack} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Go back" data-id="element-111">
              <ArrowLeftIcon className="w-6 h-6 text-[#1f5070]" data-id="element-112" />
            </button>}
          {showLogo ? <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYmeFB35HhojatJVz8XpFb/PickleballBruneiLogoC.webp" alt="Pickleball Brunei" className="h-10 object-contain" data-id="element-113" /> : <h1 className="text-xl font-bold tracking-tight" data-id="element-114">{title}</h1>}
        </div>
        <div className="flex items-center gap-2" data-id="element-115">
          {showCart && <button onClick={onCartClick} className="relative p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label={`Shopping cart with ${cartItemCount} items`} data-id="element-116">
              <ShoppingCartIcon className="w-6 h-6 text-[#1f5070]" data-id="element-117" />
              {cartItemCount > 0 && <span className="absolute -top-1 -right-1 bg-[#3dc7e3] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center" data-id="element-118">
                  {cartItemCount > 9 ? '9+' : cartItemCount}
                </span>}
            </button>}
          {showNotifications && <NotificationBadge count={notificationCount} onClick={onNotificationClick} data-id="element-119" />}
          {actionButton && <div data-id="element-120">{actionButton}</div>}
        </div>
      </div>
    </header>;
}